import { IProductSideNav } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';
import { isDevModePrereq, Prereq } from '@adaptiva/core/prereq';
import { EJavaClassNames, GlobalPermissions, hasGlobalUiPermissionPrereq, hasSomeProductsPrereq, hasVisibleObjectPrereq, serverMetadataFlagPrereq } from '@adaptiva/data-service';

export const PLATFORM_SIDENAV_ITEMS: IProductSideNav = {
	productName: 'Platform',
	sections: [
		{
			title: 'Platform Features',
			isCollapsed: true,
			items: [
				{
					display: 'Actions',
					route: '/actions',
					icon: 'faWrench',
					linkedRoutes: ['/actions/edit/:id'],
					prerequisites: [
						hasSomeProductsPrereq(...Licensing.getEnterpriseProducts().filter(p => p !== Licensing.Products.OneSite.INVENTORY)),
						hasVisibleObjectPrereq(EJavaClassNames.ActionServerObject),
					],
				},
				{
					display: 'Assets',
					icon: 'faDesktop',
					children: [
						{
							display: 'Devices',
							route: '/assets/devices',
							linkedRoutes: ['/endpoint-vm/dashboards/device-details/:id']
						},
						{
							display: 'Groups',
							route: '/assets/groups',
							linkedRoutes: ['/assets/groups/edit/:id', '/endpoint-vm/dashboards/group-details/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.Group)]
						},
						{
							display: 'Locations',
							route: '/assets/locations',
							children: [],
							linkedRoutes: ['/assets/locations/edit/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.Locations)]
						},
						{
							display: 'Tenants',
							route: '/assets/tenants',
							linkedRoutes: ['/assets/tenants/edit/:id'],
							prerequisites: [hasSomeProductsPrereq(Licensing.Products.Server.MSP)],
						}
					],
					prerequisites: [hasGlobalUiPermissionPrereq(GlobalPermissions.PERMISSIONS_FOR_ASSETS_TABLE_VIEW)]
				},
				{
					display: 'Dashboards',
					icon: 'faChartBar',
					children: [
						{
							display: 'Dashboards',
							route: '/dashboards/user-dashboards',
							linkedRoutes: ['/dashboards/user-dashboards/:dashboardId'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.UserDashboard)],
						},
						{
							display: 'Subscriptions',
							route: '/dashboards/subscriptions',
							linkedRoutes: ['/dashboards/subscriptions/edit/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.UserDashboardSubscription)],
						},
						{
							display: 'Data Providers',
							route: '/dashboards/data-providers',
							linkedRoutes: ['/dashboards/data-providers/edit/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.DataProvider)],
						},
					],
					linkedRoutes: ['/dashboards/view/:id'],
				},
				{
					display: 'Forms',
					route: '/forms',
					icon: 'faClipboard',
					linkedRoutes: ['/forms/edit/:id'],
					prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.WebForm)],
				},
				{
					display: 'Memory Pipeline',
					route: '/memory-pipeline',
					icon: 'faTimeline',
					prerequisites: [isDevModePrereq()]
				},
				{
					display: 'Schedules',
					route: '/schedules',
					icon: 'faClock',
					linkedRoutes: ['/schedules/edit/:id'],
					prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.Schedule)]
				},
				{
					display: 'Sensors',
					route: '/sensors',
					icon: 'faRobot',
					linkedRoutes: ['/sensors/edit/:id'],
					prerequisites: [
						hasSomeProductsPrereq(...Licensing.getEnterpriseProducts()),
						hasVisibleObjectPrereq(EJavaClassNames.SensorServerObject),
					],
				},
				{
					display: 'Sensor Action Policies',
					route: '/sensor-action-policies',
					icon: 'faClipboard',
					linkedRoutes: ['/sensor-action-policies/edit/:id'],
					prerequisites: [
						hasVisibleObjectPrereq(EJavaClassNames.SensorActionExecutionPolicy),
						isDevModePrereq()
					]
				},
				{
					display: 'Tool Foundry',
					icon: 'faHammer',
					children: [
						{
							display: 'Custom Tools',
							route: '/tool-foundry/custom-tools',
							linkedRoutes: ['/tool-foundry/custom-tools/edit/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.CustomToolObject)],
						},
						{
							display: 'PowerShell Cmdlets',
							route: '/tool-foundry/powershell-cmdlets',
							linkedRoutes: ['/tool-foundry/powershell-cmdlets/edit/:id'],
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.PSCmdletObject)],
						}
					],
					prerequisites: [
						Prereq.not(
							Prereq.or(
								serverMetadataFlagPrereq('cloudTenant'),
								serverMetadataFlagPrereq('cloudPortal'),
							)
						),
						hasSomeProductsPrereq(...Licensing.getEnterpriseProducts()),
					],
				},
				{
					display: 'Workflows',
					icon: 'faProjectDiagram',
					children: [
						{
							display: 'Designer',
							route: '/workflows/designer',
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.Workflow)],
						},
						{
							display: 'Activities',
							route: '/workflows/activities',
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.WorkflowActivity)],
						},
						{
							display: 'Audit Policy',
							route: '/workflows/audit/policy',
							prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.AuditPolicy)],
						},
						{
							display: 'Execution Policies',
							children: [
								{
									display: 'Client',
									route: '/workflows/execution-policies/client',
									linkedRoutes: ['/workflows/execution-policies/client/edit/:id'],
									prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.ClientWorkflowExecutionPolicy)],
								},
								{
									display: 'Server',
									route: '/workflows/execution-policies/server',
									linkedRoutes: ['/workflows/execution-policies/server/edit/:id'],
									prerequisites: [hasVisibleObjectPrereq(EJavaClassNames.ServerWorkflowExecutionPolicy)],
								}
							]
						}
					],
					prerequisites: [hasSomeProductsPrereq(...Licensing.getEnterpriseProducts())],
				},
			]
		}
	]
};
